import { FC } from 'react';
import { Button, ButtonSize, ButtonWidth, Drawer, useBreakpoint, useTranslation } from '@nextgen-web-framework/all';
import HtmlContent from '../../HtmlContent/HtmlContent';
import styles from './SubscriptionDetailsDrawer.module.scss';

export interface SubscriptionDetailsDrawerProps {
  showDrawer: (val: boolean) => void;
  longDescription?: string;
}

const SubscriptionDetailsDrawer: FC<SubscriptionDetailsDrawerProps> = (
  props: SubscriptionDetailsDrawerProps,
): JSX.Element => {
  const { showDrawer, longDescription = '' } = props;
  const t = useTranslation();
  const viewPortType = useBreakpoint();

  const closeDrawer = () => {
    showDrawer(false);
  };

  return (
    <Drawer
      header={<div>{t('subscription.subscriptionSelection.subscriptionDetailsDrawerTitle')}</div>}
      bottomGap={0}
      closeIcon={true}
      closeOnBackdropClick={true}
      onClose={closeDrawer}
      footer={
        !['xs', 'sm', 'md'].includes(viewPortType) && (
          <Button
            data-testid="cancel-testid"
            title={t('subscription.subscriptionSelection.backButtonText')}
            onClick={closeDrawer}
            size={ButtonSize.MEDIUM}
            buttonWidth={ButtonWidth.FULL_WIDTH}
          />
        )
      }
      useReactPortal={true}
      portalContainerId="react-portal-drawer"
    >
      <div className={styles['plan-long-desc']}>
        <HtmlContent content={longDescription} />
      </div>
    </Drawer>
  );
};

export default SubscriptionDetailsDrawer;
